export const COLUMN_WIDTHS = {
  date: '168px',
  type: '192px',
  amount: '144px',
  status: '264px',
};
